// extracted by mini-css-extract-plugin
export default {"root":"BookingTimeInfo_root__loyhs","bookingInfo":"BookingTimeInfo_bookingInfo__zVInC","dateSection":"BookingTimeInfo_dateSection__WPGtq"};